import { motion } from "framer-motion";
import { CalendarCheck, Rocket } from "lucide-react";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { EImg, T } from "@/context/ContentContext";

const STATS = [
  { icon: CalendarCheck, value: "1+ Year", label: "of experience", id: "founder-stat-experience" },
  { icon: Rocket, value: "19", label: "Age he started the company", id: "founder-stat-age" },
];

export function FounderSection() {
  return (
    <section className="relative bg-ink text-cream overflow-hidden grain py-24 sm:py-32" data-testid="founder-section">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 relative">
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }} className="relative max-w-sm mx-auto lg:mx-0">
            <div className="relative arch overflow-hidden aspect-[4/5] bg-[#ECECEC]">
              <EImg place="bottom-4 left-4" k="founder.photo" src="/brand/founder.jpg" alt="Aniket Singh Chautale, Founder of Trippy Tastic" className="h-full w-full object-cover object-top" data-testid="founder-photo" />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:-right-10 h-28 w-28 sm:h-32 sm:w-32 rounded-full bg-blush text-ink grid place-items-center text-center rotate-[-8deg] shadow-xl" data-testid="anniversary-badge">
              <span>
                <T k="founder.badge.num" className="block font-display text-4xl font-black leading-none">1</T>
                <T k="founder.badge.text" className="block eyebrow text-[9px] tracking-[0.12em] mt-1 leading-tight max-w-[5.5rem] mx-auto">Year of Trippy Tastic</T>
              </span>
            </div>
          </motion.div>
        </div>
        <div className="lg:col-span-7">
          <Reveal><T k="founder.eyebrow" as="p" className="eyebrow text-blush mb-5">Meet the founder</T></Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.03em] leading-[0.95]" data-testid="founder-name">
            <MaskLines inView delay={0} lines={[<T k="founder.name.0">Aniket Singh</T>, <T k="founder.name.1" className="font-serif italic font-normal text-blush">Chautale.</T>]} />
          </h2>
          <Reveal delay={0.1}>
            <T k="founder.role" as="p" className="mt-3 eyebrow text-cream/70">Founder, Trippy Tastic</T>
            <p className="mt-8 text-lg text-cream/85 leading-relaxed max-w-xl" data-testid="founder-bio">
              <T k="founder.bio">With a passion for travel and a vision to simplify the visa and travel process, Aniket Singh Chautale founded Trippy Tastic. He leads the company's strategic direction, client relations and overall growth, ensuring seamless, reliable and personalized travel solutions for every customer.</T>
            </p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-4 max-w-lg">
            {STATS.map(({ icon: Icon, value, label, id }, i) => (
              <Reveal key={id} delay={0.15 + i * 0.08} className="rounded-3xl border border-cream/15 p-5 sm:p-6" data-testid={id}>
                <Icon className="h-6 w-6 text-blush" />
                <T k={`founder.stat.${i}.value`} as="p" className="mt-4 font-display text-3xl sm:text-4xl font-extrabold">{value}</T>
                <T k={`founder.stat.${i}.label`} as="p" className="text-sm text-cream/70">{label}</T>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
